import { render } from "./WebVersionInfoW.vue?vue&type=template&id=74ad9fe6&scoped=true"
import script from "./WebVersionInfoW.vue?vue&type=script&lang=js"
export * from "./WebVersionInfoW.vue?vue&type=script&lang=js"

import "./WebVersionInfoW.vue?vue&type=style&index=0&id=74ad9fe6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ad9fe6"]])

export default __exports__